import { render, staticRenderFns } from "./assetsTable.vue?vue&type=template&id=56a4a7d6&"
import script from "./assetsTable.vue?vue&type=script&lang=ts&"
export * from "./assetsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports